<template>
  <div>
    <div class="vx-row" v-show="licences.length">
      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <h2 class="text-center"> {{$t("TxtUnlockOne")}} </h2>
          <p class="mt-4">
            {{$t("TxtUnlockTwo")}}
            <strong>{{ dispositivo.alias || dispositivo.device }}</strong> {{$t("TxtUnlockThree")}}
          </p>
          <p
            class="mt-4"
          >{{$t("TxtUnlockFour")}}</p>
          <p
            class="mt-4"
          >{{$t("TxtUnlockFive")}}</p>
          <p class="mt-4 text-danger">
            <strong> {{$t("TxtUnlockSix")}} </strong>
          </p>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 mb-base">
        <vx-card>
          <h2 class="text-center mb-4"> {{$t("TxtUnlockSeven")}} </h2>
          <form @submit="salvar">
            <vs-table ref="table" :data="licences">
              <template slot="thead">
                <vs-th class="text-center">{{$t("Select")}}</vs-th>
                <vs-th class="text-center">{{$t("ShelfLife")}}</vs-th>
                <vs-th class="text-center text-nowrap">{{$t("AcquiredIn")}}</vs-th>
              </template>

              <template>
                <vs-tr :data="linha" :key="index" v-for="(linha, index) in licences">
                  <vs-td class="text-center">
                    <vs-radio v-model="licenceIdSelected" :vs-value="linha.id"></vs-radio>
                  </vs-td>
                  <vs-td class="text-center">
                    <span v-if="linha.months == 1">{{$t("OneMonth")}}</span>
                    <span v-else-if="linha.months > 1">{{linha.months}} {{$t("Months")}}</span>
                    <span v-else-if="linha.days == 1">1 {{$t("Day")}}</span>
                    <span v-else>{{linha.days}} {{$t("Days")}}</span>
                  </vs-td>
                  <vs-td class="text-center text-nowrap">
                    <span>{{linha.date_added | formatDateTime}}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-checkbox v-model="confirmacao" class="mb-3 mt-4"> {{$t("ConfirmTerms")}} </vs-checkbox>

            <vs-button
              class="w-full md:w-auto mt-4 mr-4"
              @click="salvar"
              :disabled="!confirmacao || !licenceIdSelected"
            >
              <i class="far fa-save"></i> {{$t("UnlockContent")}}
            </vs-button>

            <vs-button color="danger" type="border" class="w-full md:w-auto mt-4" to="/dispositivo">
              <i class="far fa-times"></i> {{$t("Cancel")}}
            </vs-button>
            <button type="submit" style="display: none"></button>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      confirmacao: false,
      uid: "",
      dispositivo: "",
      licences: [],
      licenceIdSelected: "",
    };
  },
  mounted: function () {
    if (!this.$route.params.uid) {
      this.$router.push("/dispositivo");
    }

    this.uid = this.$route.params.uid;
    this.$api
      .get("/api/v1/licence/list")
      .then((response) => {
        this.licences = response.data.filter(
          (licence) => licence.product.type === "MOBILE"
        );
        if (!this.licences.length) {
          this.$router.push("/dispositivo");

          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: "Você não possui nenhuma licença.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      })
      .catch(() => {});
  },
  methods: {
    salvar: function () {
      this.$api
        .post("/api/v1/licence/assign", {
          device: {
            uid: this.uid,
          },
          licence: this.licenceIdSelected,
        })
        .then(() => {
          this.$router.push("/dispositivo");
          this.$vs.notify({
            time: 6000,
            text: "Dispositivo Desbloqueado com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>
